import React, { useState } from 'react';
import '../App.css';

const LinkCreator = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [link, setLink] = useState('');

    const createLink = () => {
        const currentUrl = window.location.href;
        const newLink = `${currentUrl}?f=${firstName}&l=${lastName}`;
        setLink(newLink);
        navigator.clipboard.writeText(newLink);
    }


    const copyLink = () => {
        navigator.clipboard.writeText(link);
    }

    const sendLink = () => {
        // implement sending link, for example via email
    }

    return (
        <div className='center' style={{ backgroundColor:'#333', padding:'2rem 0rem 2rem'}}>

<div className='auto-scale-text-mdlg color-white' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "2rem", paddingBottom: "0rem"}}>Like what you see?</div>
<div className='auto-scale-text-sm color-white' style={{ textAlign:'center', wordWrap: 'normal', paddingTop: "0rem", paddingBottom: "1rem", margin:'0 2rem 0'}}>Create a link to share a personalized version of this page to a friend. </div>


<div style={{ display:'flex', flexDirection: 'column', flexWrap: 'wrap',}}>
    <div style={{ width:'80%'}}>
        <div>
        <input style={{ padding:'1rem', margin:'1rem'}} type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First Name" />

        </div>
        <div>
        <input style={{ padding:'1rem', margin:'1rem'}} type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last Name" />

        </div>
        </div>
        <div className='center'>
        <button className='dnr_button' onClick={createLink} >Copy Link</button>

        </div>
    
</div>


            

        </div>
    );
}

export default LinkCreator;
